import * as React from 'react'
import CompleteDeliveryStep from '../CompleteDeliveryStep'
import ConfirmActivationStep from '../ConfirmActivationStep'
import ScheduleOrientationStep from '../ScheduleOrientationStep'
import strings from '../strings'
import VerifyIdentityStep from '../VerifyIdentityStep'
import { progressionCheckStepNames } from './constants'

export const progressionCheckSteps: ProgressionCheckStep[] = [
  {
    id: progressionCheckStepNames.ACCOUNT_CREATION_STEP,
    component: null,
    getTitle: () => strings.progressionCheckAccountCreatedTitle(),
  },
  {
    id: progressionCheckStepNames.VERIFY_IDENTITY_STEP,
    component: <VerifyIdentityStep />,
    getTitle: props => {
      if (props.identityVericationInProgress && props.identityInquiryId) {
        return props.isCompleted
          ? strings.progressionCheckIdentityVerifiedTitle()
          : strings.progressionCheckVerifyIdentityInProgressTitle()
      }
      return props.isCompleted
        ? strings.progressionCheckIdentityVerifiedTitle()
        : strings.progressionCheckVerifyIdentityTitle()
    },
  },
  {
    id: progressionCheckStepNames.SCHEDULE_ORIENTATION_STEP,
    component: <ScheduleOrientationStep />,
    /**
     * should not display when it reaches step 5
     * means it passed the activation step
     */
    shouldRenderChildrenComponent: props =>
      props.currentStep !== progressionCheckStepNames.COMPLETE_DELIVERY_STEP,
    getTitle: props =>
      props.isCompleted
        ? strings.progressionCheckOrientationScheduledTitle()
        : strings.progressionCheckScheduleOrientationTitle(),
  },
  {
    id: progressionCheckStepNames.CONFIRM_ACTIVATION_STEP,
    component: <ConfirmActivationStep />,
    getTitle: props =>
      props.isCompleted
        ? strings.progressionActivationConfirmedTitle()
        : strings.progressionCheckConfirmActivationTitle(),
  },
  {
    id: progressionCheckStepNames.COMPLETE_DELIVERY_STEP,
    component: <CompleteDeliveryStep />,
    getTitle: props =>
      props.isCompleted
        ? strings.progressionCheckCompleteFirstDeliveryTitleDone()
        : strings.progressionCheckCompleteFirstDeliveryTitle(),
    getIsCompleted: props => props.hasCompletedFirstDelivery,
  },
]

export type ProgressionCheckStep = {
  id: string
  component: React.ReactElement | null
  getTitle: (props: {
    isCompleted?: boolean
    identityVericationInProgress?: boolean
    identityInquiryId?: string
  }) => string
  shouldRenderChildrenComponent?: (props: { currentStep: string }) => boolean
  getIsCompleted?: (props: { hasCompletedFirstDelivery: boolean }) => boolean
}
